import React, { useEffect, useState ,useRef} from "react";
import { Box, Drawer, IconButton, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import profilecross from "../../../../assets/profilecross.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import CustomButton from "../../../../components/CustomButton";
import save from "../../../../assets/save.svg";
import WorkersMultiSelectDropdown from "../../../../components/workersMultiSelection";
import { BASE_URL } from "../../../../components/BaseUrl";
import { decryptToken } from "../../../../Utlis/Encryption";
import { useSelector } from "react-redux";

const FilterDrawer = ({ open, onClose, filters, setFilters, onApplyFilters }) => {
  const { t } = useTranslation();
  const [localFilters, setLocalFilters] = useState(filters);

  // 🔹 Status options with translations
  const statusOptions = [
    { key: "paid", label: t("statuses.paid"), value: "paid" },
    { key: "pending", label: t("statuses.Pending"), value: "pending" },
    { key: "approved", label: t("statuses.approved"), value: "approved" },
    { key: "rejected", label: t("statuses.rejected"), value: "rejected" },
  ];

  useEffect(() => {
    if (open) setLocalFilters(filters);
  }, [open, filters]);

  const startRef = useRef(null);
  const endRef = useRef(null);
  const token = useSelector((state) => state.auth.token);
const { company } = useSelector((state) => state.auth);
const decryptedToken = token ? decryptToken(token) : null;
const companyId = company?.id;

const [workers, setWorkers] = useState([]);

const fetchWorkers = async () => {
  try {
    const res = await fetch(
      `${BASE_URL}/public/workers?no_pagination=true&company_id=${companyId}&status=active`,
      {
        headers: { Authorization: `Bearer ${decryptedToken}` },
      }
    );

    const data = await res.json();
    const list = data?.data?.records || [];

    setWorkers([
      { label: t("all"), value: "all" },
      ...list.map((w) => ({
        label: `${w.first_name} ${w.last_name}`,
        value: w.id,
        email: w.email,
      })),
    ]);
  } catch (err) {
    console.error("Worker fetch error", err);
  }
};

useEffect(() => {
  if (open) {
    setLocalFilters(filters);
    fetchWorkers();
  }
}, [open]);
  const apply = () => {
    console.log("✅ Applying filters:", localFilters);
    onApplyFilters(localFilters);
    onClose();
  };

  const clear = () => {
    const cleared = { status: "", startDate: "", endDate: "",    workerId: "",   };
    console.log("♻️ Clearing filters:", cleared);
    setLocalFilters(cleared);
    onApplyFilters(cleared);
    onClose();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: 400, md: 550 },
          backgroundColor: "#E7EBEE",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          backgroundColor: "#E7EBEE",
          zIndex: 10,
          px: 2,
          py: 1.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 20,
              fontWeight: 600,
              color: "#2C384C",
            }}
          >
   {t("filterDrawer.filterExpenses") || "Filter"}          </CustomText>
        </Box>
      </Box>

      {/* Body */}
      <Box sx={{ px: 2 }}>
        <Box
          sx={{
            backgroundColor: "#FFFFFF",
            px: 3,
            py: 3,
            height: "calc(100vh - 90px)",
            overflowY: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          {/* Status Filter */}
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 18,
              fontWeight: 500,
              color: "#2C384C",
              textAlign: "left",
              pt: 3,
            }}
          >
            {t("filterDrawer.status") || "Status"}
          </CustomText>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
            {statusOptions.map((opt) => {
              const isSelected = localFilters.status === opt.value;
              return (
                <Button
                  key={opt.key}
                  variant="outlined"
                  size="small"
                  onClick={() => {
                    const newStatus = isSelected ? "" : opt.value;
                    console.log("🔘 Status selected:", newStatus);
                    setLocalFilters((prev) => ({
                      ...prev,
                      status: newStatus,
                    }));
                  }}
                  sx={{
                    borderRadius: "6px",
                    fontSize: "15px",
                    fontFamily: "Poppins, sans-serif",
                    textTransform: "none",
                    py: 0.8,
                    px: 2,
                    color: isSelected ? "#006EC2" : "#363333",
                    border: isSelected
                      ? "2px solid #006EC2"
                      : "2px solid #091E4224",
                    backgroundColor: "transparent",
                  }}
                >
                  {opt.label}
                </Button>
              );
            })}
          </Box>


<Box mt={3}>
  <WorkersMultiSelectDropdown
    label={t("employee")}
    values={localFilters.workerId ? [localFilters.workerId] : []}
    options={workers}
    enableSearch
    onChange={(e) => {
      const selected = e.target.value || [];
      // The last entry is whichever option was just clicked (checked or unchecked).
      const value = selected.length ? selected[selected.length - 1] : "";
      setLocalFilters((prev) => ({
        ...prev,
        workerId: value,
      }));
    }}
    renderValue={(selected) =>
      workers.find((w) => w.value === selected[0])?.label || ""
    }
    renderOption={(props, option) => (
      <li {...props}>
        <span>{option.label}</span>
        {option.email && (
          <span style={{ fontSize: 12, color: "#888" }}>
            {option.email}
          </span>
        )}
      </li>
    )}
  />
</Box>


          {/* Date From */}
          <Box sx={{ mt: 3 }}>
            <label className="field_label">
              {t("filterDrawer.startDate") || "Start Date"}
            </label>
            {/* <input
              type="date"
              value={localFilters.startDate || ""}
              onChange={(e) =>
                setLocalFilters((prev) => ({
                  ...prev,
                  startDate: e.target.value,
                }))
              }
              className="project_input"
              style={{ width: "100%", height: 40 }}
            /> */}
              <input
               ref={startRef}
                onClick={() => startRef.current?.showPicker()} 
    type="date"
    value={localFilters.startDate || ""}
    onChange={(e) => {
      let val = e.target.value;
      const parts = val.split("-");
      if (parts[0] && parts[0].length > 4) {
        parts[0] = parts[0].slice(0, 4); // restrict to 4 digits for year
        val = parts.join("-");
      }
      const validFormat = /^\d{0,4}(-\d{0,2}){0,2}$/;
      if (validFormat.test(val)) {
        setLocalFilters((prev) => ({
          ...prev,
          startDate: val,
        }));
      }
    }}
    className="project_input"
    style={{ width: "100%", height: 40 }}
  />
          </Box>

          {/* Date To */}
          <Box sx={{ mt: 3 }}>
            <label className="field_label">
              {t("filterDrawer.endDate") || "End Date"}
            </label>
            {/* <input
              type="date"
              value={localFilters.endDate || ""}
              onChange={(e) =>
                setLocalFilters((prev) => ({
                  ...prev,
                  endDate: e.target.value,
                }))
              }
              className="project_input"
              style={{ width: "100%", height: 40 }}
            /> */}
              <input
               ref={endRef}
                onClick={() => endRef.current?.showPicker()} 
    type="date"
    value={localFilters.endDate || ""}
    onChange={(e) => {
      let val = e.target.value;
      const parts = val.split("-");
      if (parts[0] && parts[0].length > 4) {
        parts[0] = parts[0].slice(0, 4);
        val = parts.join("-");
      }
      const validFormat = /^\d{0,4}(-\d{0,2}){0,2}$/;
      if (validFormat.test(val)) {
        setLocalFilters((prev) => ({
          ...prev,
          endDate: val,
        }));
      }
    }}
    className="project_input"
    style={{ width: "100%", height: 40 }}
  />
          </Box>

          {/* Buttons */}
          <Box sx={{ mt: 4, display: "flex", flexWrap: "wrap", gap: 2 }}>
            <CustomButton
              onClick={apply}
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <img src={save} alt="save" style={{ width: 16, height: 16 }} />
                  {t("filterDrawer.apply") || "Apply"}
                </Box>
              }
              size="medium"
            />
            <Button
              variant="outlined"
              onClick={clear}
              sx={{
                fontSize: 15,
                textTransform: "none",
                borderRadius: "5px",
                fontFamily: "Poppins, sans-serif",
                color: "#006EC2",
                border: "2px solid #006EC2",
                px: 3,
                py: 1,
                height: "fit-content",
              }}
            >
              {t("filterDrawer.clear") || "Clear"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default FilterDrawer;
